import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58d26af8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sql-json-converter"
};
const _hoisted_2 = {
  class: "input-section"
};
const _hoisted_3 = {
  class: "button-group"
};
const _hoisted_4 = {
  class: "input-section"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("textarea", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.sqlInput = $event),
    rows: "8",
    placeholder: "请输入 SQL CREATE TABLE 语句（如：CREATE TABLE `user` {...}）"
  }, null, 512), [[_vModelText, $data.sqlInput]])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.sqlToJson && $options.sqlToJson(...args)),
    class: "conversion-btn"
  }, "SQL 转 JSON"), _createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.jsonToSql && $options.jsonToSql(...args)),
    class: "conversion-btn"
  }, "JSON 转 SQL"), _createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.clearInputs && $options.clearInputs(...args)),
    class: "clear-btn"
  }, "清空")]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("textarea", {
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.jsonInput = $event),
    rows: "8",
    placeholder: "请输入 JSON 格式内容（如：[{}, {}]）"
  }, null, 512), [[_vModelText, $data.jsonInput]])])]);
}